/**
 * ajax request help
 */
import axios from 'axios'
import qs from 'qs'
import cookie from './cookie'
import { showToast } from '../commponents/toast'
// sentry 数据上报
// import report from '../report'

class Ajax {

  constructor(options) {
    this.$http = axios
    this.baseUrl = options && options.baseUrl ? options.baseUrl : '/api/v1'
    this.authUrl = options && options.authUrl ? options.authUrl : '/auth/weixin'
    // this.report = report
    this.$store = null // vuex store
    this.isLogin = false
    this.queryMap = {}
    this.createMap = {}
    this.putWayMap = {}
    this.patchMap = {}
    this.deleteMap = {}
    this.next = ''
    // 输出提示
    this.showTips = (tips) => {
      if (window.console) {
        console.log(tips)
      }
    }
    // 通用拦截器
    if (options && typeof options.success === 'function') {
      this.success = options.success
    } else {
      this.success = res => { }
    }
    // axios.defaults.headers.common['channelType'] = 'wx' // 干掉这个看是否报 WeixinJSBridge 的错
    // request 请求拦截器
    // 给POST请求头加上x-crsf-token
    axios.interceptors.request.use(
      config => {
        let csrftoken = cookie.getCookie('csrf-token')
        if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(config.method) && !axios.credentials) {
          config.headers.common['X-CSRF-Token'] = csrftoken
        }
        return config
      },
      err => {
        return Promise.reject(err)
      }
    )

    // ajax 全局错误处理
    axios.interceptors.response.use(
      response => {
        // 自定义的错误在此处统一处理，不必在组件中处处处理
        if (response.data.code !== 0) {
          showToast(response.data.message)
        }
        this.success(response)
        return response
      },
      err => {
        if (err.response) {
          switch (err.response.status) {
            case 404:
              showToast('请求发生404错误')
              break
            case 500:
              showToast('请求发生500错误')
              break
            case 504:
              showToast('请求超时')
              break
            case 400: // 用户没有csrf-token
            case 401: // 用户没有登录态
              let backUrl = '/' // eslint-disable-line
              let next = '' // eslint-disable-line
              if (window.location.hash === '') {
                next = backUrl = encodeURIComponent('/')
              } else {
                backUrl = encodeURIComponent(window.location.hash.substring(1))
                next = encodeURIComponent(window.location.hash)
              }
              window.location.href = location.origin
              break
            case 429:
              showToast('获取验证码超出次数限制')
              break
            default:
              showToast('error:' + err.response.status)
              break
          }
          let res = this.normalizeRes(err.response)
          return Promise.reject(res.data)   // 返回接口返回的错误信息
        }
      }
    )
  }

  normalizeRes(res) {
    if (res && typeof res.data === 'string') {
      res.data = {
        code: -1,
        message: res.data
      }
    } else if (res && res.statusText) {
      res.data = {
        code: res.status,
        message: res.statusText
      }
    } else {
      res = {
        data: {
          code: -1,
          message: '未知错误'
        }
      }
    }
    return res
  }

  setStore(store) {
    this.$store = store
  }

  // 设置用展示提示信息的函数
  setTipFn(fn) {
    this.showTips = fn
  }
  // 设置自定义的回调
  setSuccess(success) {
    this.success = success
  }

  parse(path, id) {
    if (typeof id === 'string') {
      return path + '/' + id
    }
    if (typeof id === 'object') {
      let search = '?'
      let counter = 0
      for (let key in id) {
        if (counter) search += '&'
        search += key + '=' + id[key]
        counter++
      }
      return path + search
    }
    return path
  }
  query(path, config1 = { cache: false }) {
    if (!this.queryMap[path]) { // cache path closure
      let url = ''
      this.queryMap[path] = (id, expand, config2 = {}, isReturnRes) => {
        // 合并config
        let config = Object.assign({}, config1, config2)
        // 关闭缓存
        if (!config.cache) {
          let headers = config.headers = config.headers || {}
          headers['Cache-Control'] = 'no-cahce'
          headers['If-Modified-Since'] = '0'
        }
        url = expand ? (path + '/' + expand) : path
        let newPath = id ? this.parse(url, id) : url
        let baseUrl = config.baseUrl || this.baseUrl
        return this.$http.get(baseUrl + newPath, config).then((res) => {
          return isReturnRes ? res : res.data
        }, (res) => {
          return res
        }).catch((res) => {
          throw new Error(JSON.stringify(res))
        })
      }
    }
    return this.queryMap[path]
  }

  // 增
  create(path, config1 = { cache: false }) {
    if (!this.createMap[path]) { // cache path closure
      let url = ''
      this.createMap[path] = (data, expand, config2 = {}, isReturnRes) => {
        // 合并config
        let config = Object.assign({}, config1, config2)
        // 关闭缓存
        if (!config.cache) {
          let headers = config.headers = config.headers || {}
          headers['Cache-Control'] = 'no-cahce'
          headers['If-Modified-Since'] = '0'
        }
        // 数据格式是非'aplication/json'
        if (config.emulateJSON) {
          data = qs.stringify(data)
        }
        url = expand ? (url = path + '/' + expand) : path
        let baseUrl = config.baseUrl || this.baseUrl
        return this.$http.post(baseUrl + url, data, config).then((res) => {
          return isReturnRes ? res : res.data
        }, (res) => {
          return res
        }).catch((res) => {
          throw new Error(JSON.stringify(res))
        })
      }
    }
    return this.createMap[path]
  }

  // put 方法~
  putWay(path, config1 = { cache: false }) {
    if (!this.putWayMap[path]) { // cache path closure
      let url = ''
      this.putWayMap[path] = (data, expand, config2 = {}, isReturnRes) => {
        // 合并config
        let config = Object.assign({}, config1, config2)
        // 关闭缓存
        if (!config.cache) {
          let headers = config.headers = config.headers || {}
          headers['Cache-Control'] = 'no-cahce'
          headers['If-Modified-Since'] = '0'
        }
        // 数据格式是非'aplication/json'
        if (config.emulateJSON) {
          data = qs.stringify(data)
        }
        url = expand ? (url = path + '/' + expand) : path
        let baseUrl = config.baseUrl || this.baseUrl
        return this.$http.put(baseUrl + url, data, config).then((res) => {
          return isReturnRes ? res : res.data
        }, (res) => {
          return res
        }).catch((res) => {
          throw new Error(JSON.stringify(res))
        })
      }
    }
    return this.putWayMap[path]
  }

  // patch 方法~
  patch(path, config1 = { cache: false }) {
    if (!this.patchMap[path]) { // cache path closure
      let url = ''
      this.patchMap[path] = (data, expand, config2 = {}) => {
        // 合并config
        let config = Object.assign({}, config1, config2)
        // 关闭缓存
        if (!config.cache) {
          let headers = config.headers = config.headers || {}
          headers['Cache-Control'] = 'no-cahce'
          headers['If-Modified-Since'] = '0'
        }
        // 数据格式是非'aplication/json'
        if (config.emulateJSON) {
          data = qs.stringify(data)
        }
        url = expand ? (url = path + '/' + expand) : path
        let baseUrl = config.baseUrl || this.baseUrl
        return this.$http.patch(baseUrl + url, data, config).then((res) => {
          return res.data
        }, (res) => {
          return res
        }).catch((res) => {
          throw new Error(JSON.stringify(res))
        })
      }
    }
    return this.patchMap[path]
  }

  // delete方法
  delete(path, config1 = { cache: false }) {
    if (!this.deleteMap[path]) {
      let url = ''
      this.deleteMap[path] = (data, expand, config2 = {}) => {
        // 合并config
        let config = Object.assign({}, config1, config2)
        // 关闭缓存
        if (!config.cache) {
          let headers = config.headers = config.headers || {}
          headers['Cache-Control'] = 'no-cahce'
          headers['If-Modified-Since'] = '0'
        }
        // 数据格式是非'aplication/json'
        if (config.emulateJSON) {
          data = qs.stringify(data)
        }
        url = expand ? (url = path + '/' + expand) : path
        let baseUrl = config.baseUrl || this.baseUrl
        return this.$http.delete(baseUrl + url, data, config).then((res) => {
          return res.data
        }, (res) => {
          return res
        }).catch((res) => {
          throw new Error(JSON.stringify(res))
        })
      }
    }
    return this.deleteMap[path]
  }
}

export default new Ajax()



// WEBPACK FOOTER //
// ./src/common/ajax.js